import React, { useState } from 'react';

interface User {
  id: string;
  piUserId: string;
  piWalletAddress: string;
  displayName: string;
  username: string;
  isNewUser: boolean;
  stats?: {
    totalGamesPlayed: number;
    totalWins: number;
    currentStreak: number;
  };
}

interface DashboardProps {
  user: User;
  onPlayGames: () => void;
  onSignOut: () => void;
}

const Dashboard: React.FC<DashboardProps> = ({
  user,
  onPlayGames,
  onSignOut,
}) => {
  const [isStatsExpanded, setIsStatsExpanded] = useState(false);

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-content">
          <h1>🎯 Koja Classics</h1>
          <div className="user-info">
            <span>Welcome, {user.displayName || user.username}!</span>
            <button onClick={onSignOut} className="sign-out-btn">
              Sign Out
            </button>
          </div>
        </div>
      </header>

      <main className="main-content">
        <section className="welcome-section">
          <h2>🎮 Your Gaming Dashboard</h2>
          {user.isNewUser && (
            <div className="new-user-banner">
              <p>
                🎉 Welcome to Koja Classics! Start playing to earn your first
                statistics.
              </p>
            </div>
          )}

          {/* Play Games Button */}
          <div className="play-games-section">
            <button onClick={onPlayGames} className="play-games-btn">
              🎯 Play Games
            </button>
            <p>Choose from Classic Ludo, Naija Ludo, and more!</p>
          </div>
        </section>

        <section className="stats-section">
          <div
            className="section-header"
            onClick={() => setIsStatsExpanded(!isStatsExpanded)}
          >
            <h3>📊 Your Statistics</h3>
            <span
              className={`expand-icon ${isStatsExpanded ? 'expanded' : ''}`}
            >
              ▼
            </span>
          </div>
          <div
            className={`collapsible-content ${isStatsExpanded ? 'expanded' : ''}`}
          >
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-number">
                  {user.stats?.totalGamesPlayed || 0}
                </div>
                <div className="stat-label">Games Played</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{user.stats?.totalWins || 0}</div>
                <div className="stat-label">Total Wins</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">
                  {user.stats?.totalGamesPlayed
                    ? Math.round(
                        (user.stats.totalWins / user.stats.totalGamesPlayed) *
                          100
                      )
                    : 0}
                  %
                </div>
                <div className="stat-label">Win Rate</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">
                  {user.stats?.currentStreak || 0}
                </div>
                <div className="stat-label">Current Streak</div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Dashboard;
